import React from 'react'

export const wyomingSetupVars = {
  siteId: 'wyoming',
  pathPrefix: '/wy',
  menuHeader: "Discover Wyoming's Solution for:",
  appUrl: 'https://wy.headed2.com',
  logoImg: '/images/assets/wyoming/horizontal/dark.svg',
  headerTitle: `The Wyoming CareerExplorer is a system designed for Wyoming`
}
